import React from 'react';
import SimplePrompt from '../SimplePrompt';
import { Col, Row } from 'react-bootstrap';
import Loader from '../Loader';
import { useDrag } from 'react-dnd';
import { useDrop } from 'react-dnd';
import { findIndex as _findIndex, find as _find, forEach as _forEach, findKey as _findKey } from 'lodash';

function FolderView({
  foldersDrag,
  userData,
  markFolder,
  choiceFolder,
  editFolder,
  deleteFolder,
  activdir,
  s3urlOriginal,
  s3urlThumb,
  choice,
  markFile,
  del,
  processDrop,
  addDirectory,
  getMedia,
  mediaFiles,
  mediaFolders,
  folders,
  pending,
  selectFile,
  files,
  filesDrag,
  saving,
  copyFolder,
  copyFile,
  pasteFile,
  pasteFolder,
  copiedFiles,
  copiedFolders,
  messages
}) {
  const ItemTypes = { ALL: 'alles' };

  const DropFolder = ({ accept, onDrop, index, id, parent, name, type, owner, creator }) => {
    const [{ isOver, canDrop }, drop] = useDrop({
      accept,
      drop: onDrop,
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    });
    let ownFileType = 1; // 1 = folder, 0 = file
    const [{ opacity }, drag] = useDrag({
      item: { id, type, ownFileType, owner, creator },
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
    });

    let border;
    const indexColor = _findIndex(foldersDrag, ['id', id]);

    let mark;
    let copy;
    let buttonFontColor;
    let noEvents;

    const foundIndex = _findIndex(copiedFolders, ['id', id]);


    if(foundIndex > -1){
      border = '3px solid #CF1719';
      copy = '#CF1719';
      buttonFontColor = '#FFFFFF';
      noEvents = "none"
    }

    if (indexColor > -1) {
      border = '3px solid #bde565';
      mark = "#bde565";
    }

    const isActive = isOver && canDrop;
    let backgroundColor = '#FFFFFF';
    if (isActive) {
      backgroundColor = '#bcbaba';
    } else if (canDrop) {
      backgroundColor = '#FFFFFF';
    }

    let folderColor = '#CD1216';
    let allowed = 0;

    if (userData.role === 'admin') {
      folderColor = '#626262';
      allowed = 1;
    } else {
      if (userData.username === owner) {
        folderColor = '#626262';
        allowed = 1;
      } else if (userData.username === creator) {
        folderColor = '#626262';
        allowed = 1;
      }
    }

    return (
      <div ref={drop} md={2} className="cc-media-folder" key={index}>
        <div ref={drag} className="card" style={{ backgroundColor: 'transparent', opacity, border: border }}>
          <div className="card-body">
            <div class="selectZone" style={{ cursor: 'pointer', pointerEvents: noEvents }} onClick={() => choiceFolder(id, parent)}>
              <div className="cc-card-title">
                <img src="https://creacheck-icons.s3.eu-central-1.amazonaws.com/folder-solid-cutted-svg-weiss.svg" />
                <h5 className="">{name}</h5>
              </div>
              <p className="card-text"> </p>
            </div>
            <div class="cc-card-footer">
              {allowed ? (
                <div class="inlineSet">
                  <button onClick={() => copyFolder(id)} className="btn btn-default card-button"
                          style={{ backgroundColor: copy, color:buttonFontColor}}>
                    <i className="far fa-cut"></i>
                  </button>
                  <button onClick={() => markFolder(id)} className="btn btn-default card-button"
                          style={{ marginRight: '2px', backgroundColor: mark}}>
                    <i className="far fa-arrows-alt" />
                  </button>
                  <button onClick={() => editFolder(id)} className="btn btn-default card-button">
                    <i className="fas fa-edit" />
                  </button>

                  <SimplePrompt class="card-button" onSuccess={() => deleteFolder(id)} showLabel={false} />
                </div>
              ) : (
                <div>
                  <i style={{ color: '#CF1719' }} className="far fa-ban forbiddenIcon" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DropFolderBack = ({ accept, onDrop }) => {
    const [{ isOver, canDrop }, drop] = useDrop({
      accept,
      drop: onDrop,
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    });
    const isActive = isOver && canDrop;
    let backgroundColor = '#626262';
    if (isActive) {
      backgroundColor = '#B2CE4C';
    } else if (canDrop) {
      backgroundColor = '#F626262';
    }

    return (
      <div
        ref={drop}
        md={2}
        style={{ cursor: 'pointer' }}
        className="cc-media-folder cc-media-folder-back"
        onClick={() => choiceFolder(activdir.folderInfo.parent)}
      >
        <div className="card backTo" style={{ backgroundColor }}>
          <span style={{ color: '' }}>
            <i className="far fa-arrow-alt-circle-left sizeFolderIcon" />
          </span>
          <span> {activdir.parentName}</span>
        </div>
      </div>
    );
  };

  const DragFiles = ({ name, type, index, thumb, id, fileKey, title, creator, owner }) => {
    let ownFileType = 0; // 1 = folder, 0 = file
    const [{ opacity }, drag] = useDrag({
      item: { id, type, ownFileType, owner, creator },
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
    });

    let indexColor = _findIndex(filesDrag, ['id', id]);
    let backgroundColor;
    let bg;
    let border;
    let mark;
    let copy;
    let buttonFontColor;

    const foundIndex = _findIndex(copiedFiles, ['id', id]);
    if(foundIndex > -1){
      border = '3px solid #CF1719';
      copy = '#CF1719';
      buttonFontColor = '#FFFFFF';
    }

    if (indexColor > -1) {
      bg = filesDrag[indexColor].color;
      border = '3px solid #bde565';
      mark = '#bde565';
    }
    let allowed = 0;

    let isPdf = thumb === 'application/pdf';

    if (userData.role === 'admin') {
      allowed = 1;
    } else {
      if (userData.username === owner) {
        allowed = 1;
      } else if (userData.username === creator) {
        allowed = 1;
      }
    }
    let mediaClass;

    if (thumb === 'video/mp4') {
      mediaClass = 'cc-media-video';
    } else {
      mediaClass = 'cc-media-image';
    }

    return (
      <div md={2} className={mediaClass} key={index} ref={drag} style={{ opacity }} draggable="true">
        <div className="card" style={{ backgroundColor, border: border }}>
          {thumb === 'video/mp4' ? (
            <div className="card-img-top rounded cc-card-img">
              <video controls style={{ width: '100%', height: '100%' }}>
                <source src={s3urlOriginal + fileKey} type="video/mp4" />
              </video>
            </div>
          ) : (
            <img
              className="card-img-top rounded cc-card-img"
              src={(isPdf ? '/img/pdf.svg' : s3urlThumb + thumb)}
              onClick={() => choice(id)}
              width="100%"
            />
          )}
          <div className="card-body">
            <div className="cc-card-title" style={{ cursor: 'pointer' }} onClick={() => choice(id)}>
              <h5 className="">{title || name}</h5>
              <p className="card-text"></p>
            </div>
            <div class="cc-card-footer">
              {allowed ? (
              <div className="inlineSet">
                { !isPdf && <button
                  style={{ marginRight: '2px', backgroundColor: copy, color: buttonFontColor }}
                  onClick={() => copyFile(id)}
                  className="btn btn-default card-button"
                >
                  <i className="far fa-cut"></i>
                </button> }
                <button
                  style={{ marginRight: '-2px', backgroundColor: mark}}
                  onClick={() => markFile(id)}
                  className="btn btn-default card-button"
                >
                  <i className="far fa-arrows-alt" />
                </button>
              </div>) : <></>}
              <div className="inlineSeta">
                <a href={s3urlOriginal + fileKey} target="_blank" className="btn btn-default card-button">
                  <i className="far fa-search-plus" />
                </a>
              </div>
              {allowed ? (
                <div className="inlineSet">
                  {!isPdf && <button onClick={() => choice(id)} className="btn btn-default card-button">
                    <i className="fas fa-edit" />
                  </button>}
                  <SimplePrompt class="card-button" onSuccess={() => del(id)} showLabel={false} />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleDrop = (item, folderName, folderId, mediaFiles, mediaFolders) => {
    processDrop(item.id, folderId, mediaFiles, mediaFolders, item.ownFileType, item.owner, item.creator);
  };

  return (
    <>
      <Row>
        <Col class="colSettings001">
          <div style={{ overflow: 'auto', clear: 'both' }}>
            {userData.access ? (
              <div  style={{display:"flex"}}>
                <div
                  md={2}
                  className="add-cc-media-folder"
                  style={{ color: '#FFFFFF', cursor: 'pointer' }}
                  onClick={() => addDirectory()}
                >
                  <div className="addFolder">
                    <p>
                      <span style={{ fontSize: '20px' }}>+</span> {messages.medialibrary.new_folder}
                    </p>
                  </div>
                </div>
                {!typeof copiedFolders !== undefined && copiedFolders.length > 0?
                <div
                  md={2}
                  className="add-cc-media-folder"
                  style={{ color: '#FFFFFF', cursor: 'pointer' }}
                  onClick={() => pasteFolder()}
                >
                  <div className="addFolder">
                    <p>
                      <span style={{ fontSize: '20px' }}> <i className="far fa-clone"></i></span> {messages.medialibrary.paste}
                    </p>
                  </div>
                </div>
                :<></>}
              </div>
            ) : null}
          </div>

          <div>
            {getMedia.back ? (
              <DropFolderBack
                accept={[ItemTypes.ALL]}
                onDrop={item =>
                  handleDrop(item, activdir.parentName, activdir.folderInfo.parent, mediaFiles, mediaFolders)
                }
                id={activdir.folderInfo.parent}
                name={activdir.parentName}
              />
            ) : (
              <></>
            )}
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* Dragzone */}
          <div class="folderSettingsForSmallDevice" style={{ overflow: 'auto', clear: 'both' }}>
            {pending ? (
              <Loader />
            ) : folders && folders.length > 0 ? (
              folders.map((folder, index) => (
                <DropFolder
                  accept={[ItemTypes.ALL]}
                  onDrop={item => handleDrop(item, folder.name, folder.id, mediaFiles, mediaFolders)}
                  key={index}
                  index={index}
                  id={folder.id}
                  parent={folder.parent}
                  name={folder.name}
                  type={ItemTypes.ALL}
                  creator={folder.creator ? folder.creator.username : null}
                  owner={folder.owner ? folder.owner.username : null}
                />
              ))
            ) : (
              <div style={{ margin: '20px 0' }}>
                <i className="fas fa-exclamation-triangle" style={{ color: '#CF1719', fontSize: '20px' }}></i>
                <span> {messages.medialibrary.no_folder_created}</span>
              </div>
            )}

            {userData.access ? (
              <div md={2} className="cc-media-folder">
                <div className="card add-cc-media-folder-circle">
                  <i
                    className="far fa-plus-circle"
                    style={{ color: '#FFFFFF', fontSize: '100px', cursor: 'pointer' }}
                    onClick={() => addDirectory()}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="extraStyle"></Col>
      </Row>
      <Row>
        <Col>
          <h3>
            <i className="far fa-images" /> {messages.medialibrary.media}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <div class="mediaSettingsForSmallDevice" style={{ overflow: 'auto', clear: 'both' }}>
            {userData.access ? (
              <div style={{display:"flex"}}>
                <div md={2} className="add-cc-media-folder" style={{ color: '#FFFFFF' }}>
                  <div className="addFolder">
                    <label htmlFor="file-input" style={{ cursor: 'pointer' }}>
                      <p>
                        <span style={{ fontSize: '20px' }}>+</span> {messages.medialibrary.upload_media}
                      </p>
                    </label>
                    <input id="file-input" type="file" accept="image/*, video/mp4, application/pdf" multiple onChange={selectFile} />
                  </div>
                </div>
                {typeof copiedFiles !== undefined && copiedFiles.length > 0 ?
                <div
                  md={2}
                  className="add-cc-media-folder"
                  style={{ color: '#FFFFFF', cursor: 'pointer' }}
                  onClick={() => pasteFile()}
                >
                  <div className="addFolder">
                    <p>
                      <span style={{ fontSize: '20px' }}> <i className="far fa-clone"></i></span> {messages.medialibrary.paste}
                    </p>
                  </div>
                </div>
                  : <></>}
              </div>
            ) : null}

            {saving || pending ? (
              <Loader />
            ) : files && files.length > 0 ? (
                files.map((file, index) => (
                <DragFiles
                  name={file.filename}
                  type={ItemTypes.ALL}
                  key={index}
                  index={file.index}
                  thumb={file.thumb}
                  id={file.id}
                  fileKey={file.key}
                  title={file.title}
                  creator={file.creator ? file.creator.username : null}
                  owner={file.owner ? file.owner.username : null}
                />
              ))
            ) : pending ? (
              <Loader />
            ) : (
              <div style={{ margin: '20px 0' }}>{messages.medialibrary.no_media_found}</div>
            )}
            {userData.access ? (
              <div md={2} className="cc-media-image">
                <div className="card add-cc-media-image">
                  <div className="image-upload">
                    <label htmlFor="file-input" style={{ cursor: 'pointer' }}>
                      <span style={{ color: '' }}>
                        <i
                          className="far fa-plus-circle"
                          style={{ color: '#FFFFFF', marginTop: '28px', fontSize: '100px', cursor: 'pointer' }}
                        />
                      </span>
                    </label>
                    <input id="file-input" type="file" accept="image/*, video/mp4, application/pdf" multiple onChange={selectFile} />
                  </div>
                  <div className="card-body">
                    <p className="card-text"></p>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
}
export default FolderView;
